import { render, staticRenderFns } from "./sub-top-image.vue?vue&type=template&id=50977a46&scoped=true&"
import script from "./sub-top-image.vue?vue&type=script&lang=js&"
export * from "./sub-top-image.vue?vue&type=script&lang=js&"
import style0 from "./sub-top-image.vue?vue&type=style&index=0&id=50977a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50977a46",
  null
  
)

export default component.exports